import React, { useState, useEffect } from "react";
import { observer } from 'mobx-react';
import { Box, Typography, Paper } from "@mui/material";
import styles from './order-summary.module.scss'
import RoundButton from "../shared/components/round-btn";
import { OceanProtocol } from "iconsax-react";
import OrderSummaryUiStore from "./order-summary-ui-store";
import ChargeModal from "../wallet/charge-modal";

const uiStore = new OrderSummaryUiStore();

const OrderSummary = observer(({ history, context }) => {
    const [showPaymentModal, setShowPaymentModal] = useState(false);

    useEffect(() => {
        async function fetchData() {
            uiStore.initliazeContext(context);
        }

        fetchData()
    }, [context]);

    return (
        <>
            <Box sx={{ mt: 2 }}>
                <Typography variant="h6" color='#242333' fontWeight={700}>Order Summary</Typography>
            </Box>
            <Box sx={{ display: "flex", justifyContent: 'center', mt: 2 }}>
                <Paper variant="round" sx={{ p: 4, width: '100%', display: 'flex', justifyContent: 'space-between' }}>
                    <Box sx={{ display: 'flex' }}>
                        <Box className={styles.walletIcon}>
                            <OceanProtocol
                                size="32"
                                color="#ffb300"
                                variant="Bulk"
                            />
                        </Box>
                        <Box sx={{ ml: 2, mt: 1 }}>
                            <Typography fontWeight={600}>Premium membership</Typography>
                            <Typography color='#949494'>$3.99</Typography>
                        </Box>
                    </Box>
                </Paper>
            </Box>
            <Box sx={{ display: "flex", justifyContent: 'flex-end', mt: 2 }}>
                <RoundButton size="large" onClick={() => setShowPaymentModal(true)} variant="contained" sx={{ height: 'fit-content', mt: 2 }}>Pay Now</RoundButton>
            </Box>
            <ChargeModal show={showPaymentModal} setShow={setShowPaymentModal} />
        </>
    );
});

export default OrderSummary;